function generateLogSpace(min: number, max: number, steps: number): number[] {
  if (min <= 0) min = 0.0001;
  const minLog = Math.log10(min);
  const maxLog = Math.log10(max);
  const delta = (maxLog - minLog) / (steps - 1);
  const values: number[] = [];
  for (let i = 0; i < steps; i++) {
    values.push(Math.pow(10, minLog + i * delta));
  }
  return values;
}

export function generateFitCurvePoints(
  minSon: number,
  maxSon: number,
  a_max_calc: number,
  b_exponent: number
) {
  const sonFit = generateLogSpace(minSon, maxSon, 100);
  return sonFit
    .map(son => [son, a_max_calc * Math.pow(son, b_exponent)])
    .filter(p => p[1] > 0.001);
}